import SponsorRegistrationList from './SponsorRegistrationList'
import SponsorRegistrationEdit from './SponsorRegistrationEdit'
import SponsorRegistrationIcon from '@material-ui/icons/AllInbox';

export default {
  list: SponsorRegistrationList,
  edit: SponsorRegistrationEdit,
  icon: SponsorRegistrationIcon,
  options: { label: 'Sponsor Registration' }
}